import angular from 'angular';

import {ServicesModule} from '../services/services.module';

import {
    CompareToDirective,
    IncludeUppercaseDirective,
    IncludeLowercaseDirective,
    IncludeNumberDirective,
    IncludeSpecialCharDirective,
    MinlengthDirective,
    ValidateUserEmailDirective
} from './index';

export const DirectivesModule = angular
    .module('mmsApp.directives', [
        ServicesModule
    ])
    .directive(CompareToDirective.name, CompareToDirective.directive)
    .directive(IncludeUppercaseDirective.name, IncludeUppercaseDirective.directive)
    .directive(IncludeLowercaseDirective.name, IncludeLowercaseDirective.directive)
    .directive(IncludeNumberDirective.name, IncludeNumberDirective.directive)
    .directive(IncludeSpecialCharDirective.name, IncludeSpecialCharDirective.directive)
    .directive(MinlengthDirective.name, MinlengthDirective.directive)
    .directive(ValidateUserEmailDirective.name, ValidateUserEmailDirective.directive)
    .name;


// WEBPACK FOOTER //
// ./src/app/directives/app.directives.module.js